module.exports = __webpack_public_path__ + "static/media/MICHELL GYRODEC.b35b8532.png";